// src/api/user-management-api.ts
import { userManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { Role } from "@src/types/user-management";

export const getValidUserRoles = async (namespace: string) => {
  const url = userManagerUrlEnvVar();

  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<Role[]>(
      `${url}/api/v1/ns/${namespace}/roles/valid-user-roles`,
      {
        headers: headers,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw err;
    } else {
      throw new Error("An unexpected error occurred while fetching roles.");
    }
  }
};
